import { z } from 'zod';

export const getDataTypeSchema = z.object({
  id: z.string(),
  name: z.string(),
  code: z.number(),
  remarks: z.string().optional(),
  mask: z.string().optional(),
});

export const getDataTypesSchema = z.array(getDataTypeSchema);
export type GetDataTypes = z.infer<typeof getDataTypesSchema>;
